import type { NoteListItemResponse } from '@store/generated/notes';

import type { UserNoteTypeII } from '../../../types/types';

/**
 * Converts a v2 NoteListItemResponse to the legacy UserNoteTypeII type.
 * This shim allows reuse of existing NoteListRow without a full refactor.
 */
export function convertNoteListItem(item: NoteListItemResponse): UserNoteTypeII {
  return {
    note_id: item.note_id,
    note_title: item.note_title ?? '',
    status: item.status as UserNoteTypeII['status'],
    summary: item.summary ?? '',
    time_uploaded: item.time_uploaded ?? 0,
    issuing_user: item.issuing_user_id,
    issuing_user_name: item.issuing_user_name ?? undefined,
    internal_title: '',
    has_feedback: false,
    is_rated: false,
    is_signed: item.is_signed,
    patient_id: item.patient_id ?? undefined,
    patient_name: item.patient_name ?? undefined,
    completion_status: item.completion_status as UserNoteTypeII['completion_status'],
    completion_timestamp: item.completion_timestamp ?? undefined,
    requires_cosigning: item.requires_cosigning ?? undefined,
  };
}
